var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96153 2C2.43049 2 2 2.43664 2 2.97525V10.4773C2 10.9117 2.51785 11.1293 2.82071 10.8221L4.71961 8.89609L6.59699 10.8003L9.59839 5.58155L9.60291 5.5738L8.79902 4.75844L10.6979 2.83243C11.0008 2.52524 10.7863 2 10.358 2H2.96153Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48156 13.726L7.65155 11.8699L10.6574 6.6434L12.4875 8.49957L12.483 8.50733L9.48156 13.726Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 15.7922L10.5361 14.7957L13.542 9.56915L15.598 11.6545C15.9735 12.0354 15.9735 12.6529 15.598 13.0337L12.8784 15.7922C12.5029 16.173 11.8941 16.173 11.5186 15.7922Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9613 14.6733C15.6797 14.3876 15.6797 13.9245 15.9613 13.6389C16.2429 13.3532 16.6995 13.3532 16.9811 13.6389L19.0209 15.7077C19.1147 15.8029 19.2669 15.8029 19.3608 15.7077C19.4547 15.6125 19.4547 15.4581 19.3608 15.3629L18.9529 14.9491C18.6712 14.6635 18.6712 14.2003 18.9529 13.9147C19.2345 13.6291 19.6911 13.6291 19.9727 13.9147L20.3807 14.3285C21.0378 14.995 21.0378 16.0756 20.3807 16.7421C19.7235 17.4086 18.6581 17.4086 18.001 16.7421L15.9613 14.6733Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.859 15.8404C14.5773 15.5548 14.1207 15.5548 13.8391 15.8404C13.5575 16.1261 13.5575 16.5892 13.8391 16.8748L16.2188 19.2885C16.5004 19.5741 16.5004 20.0372 16.2188 20.3229C15.9371 20.6085 15.4805 20.6085 15.1989 20.3229L14.859 19.9781C14.5773 19.6924 14.1207 19.6924 13.8391 19.9781C13.5575 20.2637 13.5575 20.7268 13.8391 21.0125L14.179 21.3573C15.0239 22.2142 16.3937 22.2142 17.2386 21.3573C18.0835 20.5004 18.0835 19.111 17.2386 18.2541L14.859 15.8404Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8459 18.1112C19.1275 17.8255 19.5841 17.8255 19.8657 18.1112L21.7888 20.0617C22.0704 20.3473 22.0704 20.8104 21.7888 21.0961C21.5072 21.3817 21.0506 21.3817 20.7689 21.0961L18.8459 19.1456C18.5642 18.8599 18.5642 18.3968 18.8459 18.1112Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireworks);
export default __webpack_public_path__ + "static/media/fireworks.f0a55b4207ee49b40f90e720b000c6be.svg";
export { ForwardRef as ReactComponent };